import { FC } from 'react';
import { PageTitle, PageLink } from '../../../_metronic/layout/core';
import { View } from './components/View';
import { useParams } from 'react-router-dom';
import { decryptId } from '../../../_metronic/helpers';

const RisksPage: FC = () => {
  const { id_oportunidad, id } =
    useParams<{ id_oportunidad: string; id: string }>();

  const riskId = decryptId(id);
  const oportunityId = decryptId(id_oportunidad);
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Oportunidades',
      path: '/oportunidades/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: 'Editar',
      path: `/oportunidades_edit/${id_oportunidad}`,
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: 'Riesgos',
      path: '#/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>
        {riskId ? 'Editar riesgo' : 'Nueva riesgo'}
      </PageTitle>

      <View
        id={riskId ? riskId : '0'}
        oportunityId={oportunityId ? oportunityId : '0'}
      />
    </>
  );
};

export { RisksPage };
